<template>
    <div class="columns is-multiline is-mobile bng-game-list">
        <div
            v-for="game in games"
            :key="game.id"
            class="column is-6-mobile is-4-tablet is-3-desktop is-2-widescreen is-2-fullhd bng-game-list-item"
        >
            <div class="card" :class="game.category" @click="openGame(game)">
                <div class="game-card-overlay">
                    <figcaption class="game-detils fadeIn-bottom is-uppercase is-size-5">
                        <h3>
                            <template v-if="game.displayName || game.name">{{game.displayName || game.name}}</template>
                            <template
                                v-else
                            >{{`games.${game.provider}.${game.gameId}` | translate}}</template>
                        </h3>
                    </figcaption>
                </div>
                <div class="card-image">
                    <figure class="image image is-4by5" :class="isJantaBets ? 'ratio-120x106' : ''">
                        <img :src="game.thumbnailUrl" :alt="game.gameId" />
                        
                    </figure>
                </div>
            </div>
        </div>
        <div v-if="homeRoute == 'casino-main' && path == '/'" class="column column-see-more is-6-mobile is-4-tablet is-3-desktop is-2-widescreen is-2-fullhd bng-game-list-item">
            <div class="card">
                <div class="card-image">
                    <router-link :to="{name: 'slots'}" class="image image is-4by5">
                        <div class="see-more-text">
                            See More
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

export default {
    name: 'game-list',
    props: {
        games: {
            default: []
        }
    },
    computed: {
        lang() {
            return Vue.state.lang.currentLang;
        },
        client() {
            return Vue.state.client.get();
        },
        homeRoute() {
            return this.client.view.routing.homeRoute;
        },
        path(){
            return this.$route.fullPath;
        },
        clientAlias() {
            return this.client && this.client.view && this.client.view.general && this.client.view.general.alias;
        },
        isJantaBets() {
            return this.clientAlias === 'Jantabets';
        }
    },
    methods: {
        async openGame(game) {
            await Vue.router.teleport.game(game);
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/game-list/game-list.vue